import { checkPermissions } from './actionManager';
import * as filters from '@/common/filters';
import * as treeHelpers from '@/common/treeHelpers';
import log from '@/logger';

export const isLoggedIn = ({ loggedin }) => loggedin;

export const viewSettings = (state) => {
  return state.viewSettings;
};

export const flattenFilteredParts = (state) => (filter) => {
  var filtered = filters.filterParts(state, state.currentProject, '', '', '', filter, 0);
  var flattened = filters.flattenParts(filtered);

  flattened.sort((a, b) => {
    var aLateTime = a.lateTime ? a.lateTime : '9999-99-99';
    var bLateTime = b.lateTime ? b.lateTime : '9999-99-99';
    if (aLateTime < bLateTime) {
      return -1;
    } else if (aLateTime > bLateTime) {
      return 1;
    }
    if (a.startdate < b.startdate) {
      return -1;
    } else if (a.startdate > b.startdate) {
      return 1;
    }
    if (a._id < b._id) {
      return -1;
    } else if (a._id > b._id) {
      return 1;
    }
    return 0;
  });

  return flattened;
};

export const selectedPart = (state) => {
  return state.selectedPart;
};

export const selectedPartComments = (state) => {
  return state.selectedPartComments;
};

export const selectedPartInspection = (state) => {
  return state.selectedPartInspection;
};

export const selectedPartTodoItemsRemaining = (state) => {
  return state.selectedPartTodoItems.filter((i) => !i.archived && !i.checked).length;
};

export const selectedPartTodoItems = (state) => {
  return [...state.selectedPartTodoItems].sort((a, b) => {
    if (a.checked !== b.checked) {
      return a.checked ? 1 : -1;
    }
    if (a.sort === b.sort) {
      return a.title.localeCompare(b.title);
    }
    return (Number.isInteger(a.sort) ? a.sort : -1) - (Number.isInteger(b.sort) ? b.sort : -1);
  });
};

export const loggedInUserPartComments = (state) => {
  var comments = state.loggedInUserPartComments;
  return comments;
};

export const selectedStage = (state) => {
  return state.selectedStage;
};

export const partExists = (state, getters) => (id) => {
  return state.parts.hasOwnProperty(id);
};

export const fetchPart = (state, getters) => (id) => {
  var found = state.parts[id];

  if (found) {
    return found;
  }
  log.debug('getter:fetchPart.not found', id);

  return { title: 'Unknown: ' + id, _id: id, projectId: state.currentProject._id };
};

export const fetchStage = (state, getters) => (id) => {
  var found = state.stages[id];

  if (found) {
    return found;
  }

  return { title: 'Unknown: ' + id };
};

export const findNearestParentProperty = (state, getters) => (project, id, property, fallbackProperty) => {
  var parent = treeHelpers.findParent(project, id);
  var value;
  while (!value && parent && parent !== project) {
    value = getters.fetchStage(parent._id)[property];
    if (!value) {
      parent = treeHelpers.findParent(project, parent._id);
    }
  }
  if (!value) {
    return project[fallbackProperty];
  }
  return value;
};

export const hasSimplePermissions = (state, getters) => (action, payload) => {
  return checkPermissions({ type: action, payload }, state);
};

export const hasPropertyPermissions = (state, getters) => (type, property) => {
  var action = 'set' + type + 'Properties';
  var check = 'new' + type + 'Properties';
  var payload = {};
  payload[check] = {};
  payload[check][property] = 1;

  return checkPermissions({ type: action, payload }, state);
};

export const projectDraggingAllowed = (state, getters) => {
  return (
    getters.editingAllowed &&
    !state.currentProject.lockedDragNDrop &&
    getters.hasPropertyPermissions('Part', 'startdate')
  );
};

export const editingAllowed = (state, getters) => {
  return !state.currentProject.lockedForEditingBy || state.currentProject.lockedForEditingBy === state.user.username;
};

export const donePartCount = (state, getters) => {
  if (!state.parts) {
    return 0;
  }
  var donePartCount = 0;
  for (var property in state.parts) {
    if (state.parts.hasOwnProperty(property)) {
      var part = state.parts[property];
      if (part.controlFulfilled) {
        donePartCount++;
      }
    }
  }

  return donePartCount;
};

export const myAlertParts = (state, getters) => {
  var filter = {
    partManagerId: getters.loggedInPerson._id,
    filterAlerts: true,
  };
  return getters.flattenFilteredParts(filter);
};

export const partCount = (state, getters) => {
  if (!state.parts) {
    return 0;
  }
  return Object.keys(state.parts).length;
};

export const getAllPart = (state, getters) => {
  // get all part's object to array. return array
  if (!state.parts) {
    return null;
  }
  var result = Object.keys(state.parts).map(function (key) {
    return state.parts[key];
  });
  return result;
};

export const lockedForEditingByCurrentUser = (state, getters) => {
  return state.currentProject.lockedForEditingBy === state.user.username;
};

export const isAdmin = (state) => {
  return state.loggedInPerson.role === 'admin';
};

export const isDebugMode = (state) => {
  return state.loggedInPerson.debugger === true;
};

export const hasRole = (state) => (role) => {
  return state.loggedInPerson.role === role;
};

export const hasRoles = (state) => (roles) => {
  return roles.includes(state.loggedInPerson.role);
};

export const username = (state) => {
  return state.user.username;
};

export const keyword = (state) => {
  return state.setKeyword;
};

export const colours = () => {
  return [
    { title: 'Red', hexcode: '#c73d13' },
    { title: 'Purple', hexcode: '#9d61a4' },
    { title: 'Green', hexcode: '#46b071' },
    { title: 'Blue', hexcode: '#2f86a1' },
    { title: 'Orange', hexcode: '#f7aa2d' },
    { title: 'Grey', hexcode: '#fedfb5' },
    { title: 'Brown', hexcode: '#464b59' },
    { title: 'Black', hexcode: '#192230' },
    { title: 'Light Green', hexcode: '#a2bc1b' },
    { title: 'Pink', hexcode: '#e74059' },
  ];
};



// WEBPACK FOOTER //
// ./src/store/getters.js